export const getLaunchDarklyUserKey = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const targetRole = queryParams.get('targetRole');
  return targetRole;
};
